var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.1375C11.305 3.1375 12.3625 4.195 12.3625 5.5C12.3625 6.805 11.305 7.8625 10 7.8625C8.695 7.8625 7.6375 6.805 7.6375 5.5C7.6375 4.195 8.695 3.1375 10 3.1375ZM10 13.2625C13.3413 13.2625 16.8625 14.905 16.8625 15.625V16.8625H3.1375V15.625C3.1375 14.905 6.65875 13.2625 10 13.2625ZM10 1C7.51375 1 5.5 3.01375 5.5 5.5C5.5 7.98625 7.51375 10 10 10C12.4862 10 14.5 7.98625 14.5 5.5C14.5 3.01375 12.4862 1 10 1ZM10 11.125C6.99625 11.125 1 12.6325 1 15.625V17.875C1 18.4937 1.50625 19 2.125 19H17.875C18.4937 19 19 18.4937 19 17.875V15.625C19 12.6325 13.0037 11.125 10 11.125Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInfo);
export default __webpack_public_path__ + "static/media/menu-info.16b7b3768a739902f9fd335e675fd9aa.svg";
export { ForwardRef as ReactComponent };